// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '5.1.1'
export const publishDates = {
	major: '2026-05-06T16:28:18.473Z',
	minor: '2026-06-03T10:34:02.514Z',
	patch: '2026-06-12T16:41:01.371Z',
}
